import React, {useRef, useState} from "react";
import {Box, Button, Columns, Container, Heading, Notification} from "react-bulma-components";
import CustomerChargerSection from "./CustomerChargerSection";
import {useDispatch, useSelector} from "react-redux";
import {
    getDepartmentsData, getDriversData,
    getMovementData,
    getMovementRatesData,
    getMovementTypesData, getTrackingOptionsData
} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {createSetDataFreshAction, createSetMovementDataAction} from "../../actions/dataActions";
import MovementSupplierSection from "./MovementSupplierSection";
import {useMovementsRateData} from "../../hooks/useMovementsRateData";
import {movementCost} from "../../utils";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import ReactToPrint from "react-to-print";
import PrintMovementNote from "./PrintMovementNote";
import PrintGoodsDelivery from "./PrintGoodsDelivery";
import DeleteConfirmModal from "./DeleteConfirmModal";
import ConfirmModal from "./ConfirmModal";




export default function Form(props){
    const dispatch = useDispatch();
    let rateParams = {page_size: 1000};
    const noteRef = useRef();
    const goodsRef = useRef();
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    let data = useSelector(getMovementData);
    if(data && data.id && data.customer && data.customer.id){
        rateParams.contact=data.customer.id
    }
    let movementRatesLoaded = useMovementsRateData(rateParams);

    let departments = useSelector(getDepartmentsData);
    let movementRates = useSelector(getMovementRatesData);
    let movementTypes = useSelector(getMovementTypesData);
    let drivers = useSelector(getDriversData);
    let trackingOptions = useSelector(getTrackingOptionsData)

    const handleDelete = () => {
        setDeleteConfirmOpen(true);
    }

    const onDelete = () => {
        const conf = {
            method: "delete",
            url: props.endpoint+"movement/"+data.id
        }
        axios(conf).then(res => {
            setDeleteConfirmOpen(false);
            window.open("/movements", "_self");
        }).catch(err => {
            NotificationManager.error("There was an error deleting movement")
        })
    }

    const onComplete = () => {
        const conf = {
            url: props.endpoint+"movementcomplete/"+data.id,
            method: "put",
            data: data
        };

        axios(conf).then((res) => {
            dispatch(createSetMovementDataAction(res.data));
            setConfirmModalOpen(false);
        });
    };

    const validator = () => {
        if(data.customer.is_cash_sale){
            if(!(!!data.cash_sale[0].name)){
                NotificationManager.warning("Cash Sale Name is required");
                return false;
            }
            if(!(!!data.cash_sale[0].address)){
                NotificationManager.warning("Cash Sale Address is required");
                return false
            }
        }
        return true
    }

    const onSave = () => {
        const conf = {
            method: "put",
            data:data,
            url: props.endpoint+"movement/"+data.id
        }
        if(validator()) {
            axios(conf).then(res => {
                // Doing the state update this way will stop not needed api requests
                dispatch(createSetMovementDataAction(res.data));
            }).catch(err => {
                NotificationManager.error("There was an error saving movement")
            })
        }
    }

    const triggerChange = e => {
        let newMovement = {...data, [e.target.name]: e.target.value};
        newMovement = movementCost(newMovement);
        dispatch(createSetMovementDataAction(newMovement));
    };

    const onCheck = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        }
        triggerChange(toUpdate)
    };

    const onDepartmentChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        }
        triggerChange(toUpdate);
    };

    const onMovementRateChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: movementRateObjects[e.target.value]
            }
        }
        triggerChange(toUpdate);
    };

    const onMovementTypeChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: movementTypeObjects[e.target.value]
            }
        }
        triggerChange(toUpdate);
    };

    const onDriverChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: driverObjects[e.target.value]
            }
        }
        triggerChange(toUpdate);
    };

    const onTrackingOptionChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: trackingObjects[e.target.value]
            }
        }
        triggerChange(toUpdate);
    };

    const onSearchedObjChange = (e, name) =>{
        // This is for any changes that happen using async type headers
        const toUpdate = {
            target: {
                name: name,
                value: e[0]
            }
        }
        triggerChange(toUpdate);
    };

    const onCustomerChange = (e, name) => {
        // for some reason the contact section component passes e[0] to the change function instead of the entire event (not my fault)
        const toUpdate = {
            target: {
                name: name,
                value: e
            }
        }
        triggerChange(toUpdate);
    }

    const onCashSaleChange = (e, index) => {
        let cashSale = {...data.cash_sale[index]}
        cashSale[e.target.name] = e.target.value;
        data.cash_sale[index] = cashSale;
        triggerChange({target: {name: 'cash_sale', value: data.cash_sale}});
    }

    const addCashSale = () => {
        let newCashSale = {
            name: "",
            email: "",
            phone: "",
            address :"",
            contact: data.customer.id
        };
        data.cash_sale.push(newCashSale);
        triggerChange({target: {name: 'cash_sale', value: data.cash_sale}})
    }


    if(!props.loaded || !movementRatesLoaded){
        return <LoadingSpinner/>
    }

    const departmentObjects = departments.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const movementTypeObjects = movementTypes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const trackingObjects = trackingOptions.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const movementRateObjects = movementRates.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});

    const driverObjects = drivers.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {});
    const getGoToURL = () => {
        if(data.rental){
            return "/editrental/"+data.rental.id
        }
        else if(data.job){
            return "/editjob/"+data.job.id
        }
    }
    return (
        <Container>
            {(data.job || data.rental) &&
                <Box>
                    <Columns>
                        <Columns.Column>
                            <Heading>
                                {`Created From ${data.job ? "Job "+data.job.id : "Rental "+data.rental.id}`}
                            </Heading>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"warning"}
                                onClick={() => window.open(getGoToURL(), "_self")}
                            >
                                Go To
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Box>
            }
            <CustomerChargerSection
                data={data}
                departments={departments}
                movementRates={movementRates}
                movementTypes={movementTypes}
                onChange={triggerChange}
                onCheck={onCheck}
                endpoint={props.endpoint}
                onSearchedObjChange={onSearchedObjChange}
                onDepartmentChange={onDepartmentChange}
                onMovementTypeChange={onMovementTypeChange}
                onMovementRateChange={onMovementRateChange}
                onCustomerChange={onCustomerChange}
                onCashSaleChange={onCashSaleChange}
                addCashSale={addCashSale}
            />
            <MovementSupplierSection
                data={data}
                departments={departments}
                onChange={triggerChange}
                onCheck={onCheck}
                endpoint={props.endpoint}
                drivers={drivers}
                onSearchedObjChange={onSearchedObjChange}
                onDepartmentChange={onDepartmentChange}
                onDriverChange={onDriverChange}
                onCustomerChange={onCustomerChange}
            />
            <Box>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            fullwidth
                            onClick={onSave}
                            disabled={data.completed}
                        >
                            Save
                        </Button>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            fullwidth
                            onClick={() => setConfirmModalOpen(true)}
                            disabled={!data.work_complete || data.completed || data.movement_status !== "NORMAL"}
                        >
                            {(data.work_complete && data.movement_status === "NORMAL") ? "Approve" : "Work must be completed before approval and cannot be a quote"}
                        </Button>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              color={"warning"}
                              fullwidth
                            >
                              Print Goods Delivery
                            </Button>
                          )}
                          content={() => goodsRef.current}
                          bodyClass="print-portrait"
                          pageStyle="@page {
                            size: A4 portrait;
                          }"
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <ReactToPrint
                          trigger={() => (
                            <Button
                              color={"warning"}
                              fullwidth
                            >
                              Print Movement Note
                            </Button>
                          )}
                          content={() => noteRef.current}
                          bodyClass="print-portrait"
                          pageStyle="@page {
                            size: A4 portrait;
                          }"
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"danger"}
                            fullwidth
                            onClick={handleDelete}
                            disabled={data.completed}
                        >
                            Delete Movement
                        </Button>
                    </Columns.Column>
                </Columns>
            </Box>
            <div>
                <div style={{display: "none"}}>
                    <PrintMovementNote movement={data} ref={noteRef}/>
                </div>
                <div style={{display: "none"}}>
                    <PrintGoodsDelivery movement={data} ref={goodsRef}/>
                </div>
            </div>
            <DeleteConfirmModal
                open={deleteConfirmOpen}
                setOpen={setDeleteConfirmOpen}
                onDelete={onDelete}
            />
            <ConfirmModal
                movement={data}
                onConfirm={onComplete}
                show={confirmModalOpen}
                setShow={setConfirmModalOpen}
                trackingOptions={trackingOptions}
                onChange={triggerChange}
                onTrackingOptionChange={onTrackingOptionChange}
            />
        </Container>
    )

}